import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/module/activity/byModule';
import { callApi } from 'store/sagas/auth';

function* getActivityList({ payload }) {
  try {
    const { page, perPage, search, orderByColumn, orderByDirection, moduleId } = payload;
    const request = call(api.get, `/v1/admin/modules/${moduleId}/activities`, {
      page,
      search,
      per_page: perPage,
      order: orderByColumn,
      order_by: orderByDirection,
    });

    const response = yield call(callApi, request);
    if(response.status != 200 && response.status != 201) throw response;
    yield put(Creators.getActivityListSuccess(response.data));
  } catch (err) {
    yield put(Creators.getActivityListFailure('Erro ao buscar na API'));
  }
}

export default function* moduleListSaga() {
  yield all([takeLatest(Types.GET_LIST_REQUEST, getActivityList)]);
}
